import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_tooltip",
  "use": "svg_tooltip-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_tooltip\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M8.901 13H7.1V7.117H8.9V13h.001Zm0-7.853H7.1V3.53H8.9v1.616h.001Z\" fill=\"#000\" fill-rule=\"nonzero\" /><path d=\"M8 .5A7.5 7.5 0 0 0 .5 8 7.5 7.5 0 0 0 8 15.5 7.5 7.5 0 0 0 15.5 8 7.5 7.5 0 0 0 8 .5Z\" stroke=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol